//#region ../event-service/dist/service.types-CDefnrwA.js
var e = {
	SalesChannelStatusChanged: "SalesChannelStatusChanged",
	ProductCreated: "ProductCreated",
	ProductUpdated: "ProductUpdated",
	OrderCreated: "OrderCreated",
	OrderDeleted: "OrderDeleted",
	OrderRulesEvaluated: "OrderRulesEvaluated",
	OrderUpdated: "OrderUpdated",
	Printed: "Printed",
	PrintErrored: "PrintErrored"
}, t = {
	Account: "account",
	Shop: "shop",
	Order: "ORDER",
	Product: "PRODUCT",
	Print: "PRINT"
}, n = {
	Event: "Event",
	Order: "Order",
	Printing: "Printing",
	Product: "Product"
};
//#endregion
//#region ../../node_modules/.pnpm/@vue+shared@3.5.40/node_modules/@vue/shared/dist/shared.esm-bundler.js
// @__NO_SIDE_EFFECTS__
function r(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var i = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var a = () => {}, o = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), s = (e) => e.startsWith("onUpdate:"), c = Object.assign, l = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, u = Object.prototype.hasOwnProperty, d = (e, t) => u.call(e, t), f = Array.isArray, p = (e) => y(e) === "[object Map]", m = (e) => y(e) === "[object Set]", h = (e) => typeof e == "function", g = (e) => typeof e == "string", _ = (e) => typeof e == "symbol", v = (e) => typeof e == "object" && !!e, ee = (e) => (v(e) || h(e)) && h(e.then) && h(e.catch), te = Object.prototype.toString, y = (e) => te.call(e), b = (e) => y(e).slice(8, -1), x = (e) => y(e) === "[object Object]", S = (e) => g(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, C = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), w = (e, t) => !Object.is(e, t), ne = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, re, ie = () => re ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function ae(e) {
	if (f(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = g(r) ? le(r) : ae(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (g(e) || v(e)) return e;
}
var oe = /;(?![^(]*\))/g, se = /:([^]+)/, ce = /\/\*[^]*?\*\//g;
function le(e) {
	let t = {};
	return e.replace(ce, "").split(oe).forEach((e) => {
		if (e) {
			let n = e.split(se);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function ue(e) {
	let t = "";
	if (g(e)) t = e;
	else if (f(e)) for (let n = 0; n < e.length; n++) {
		let r = ue(e[n]);
		r && (t += r + " ");
	}
	else if (v(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+reactivity@3.5.40/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
function T(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var de;
function fe() {
	return de;
}
var E, pe = /* @__PURE__ */ new WeakSet(), me = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, de && (de.active ? de.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, pe.has(this) && (pe.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || ge(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, Oe(this), ye(this);
		let e = E, t = k;
		E = this, k = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && E !== this && T("Active effect was not restored correctly - this is likely a Vue internal bug."), be(this), E = e, k = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Ce(e);
			this.deps = this.depsTail = void 0, Oe(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? pe.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		xe(this) && this.run();
	}
	get dirty() {
		return xe(this);
	}
}, he = 0, D, O;
function ge(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = O, O = e;
		return;
	}
	e.next = D, D = e;
}
function _e() {
	he++;
}
function ve() {
	if (--he > 0) return;
	if (O) {
		let e = O;
		for (O = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; D;) {
		let t = D;
		for (D = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function ye(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function be(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Ce(r), we(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function xe(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Se(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Se(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === ke) || (e.globalVersion = ke, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !xe(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = E, r = k;
	E = e, k = !0;
	try {
		ye(e);
		let n = e.fn(e._value);
		(t.version === 0 || w(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		E = n, k = r, be(e), e.flags &= -3;
	}
}
function Ce(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Ce(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function we(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var k = !0, Te = [];
function Ee() {
	Te.push(k), k = !1;
}
function De() {
	let e = Te.pop();
	k = e === void 0 || e;
}
function Oe(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = E;
		E = void 0;
		try {
			t();
		} finally {
			E = e;
		}
	}
}
var ke = 0, Ae = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, je = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!E || !k || E === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== E) t = this.activeLink = new Ae(E, this), E.deps ? (t.prevDep = E.depsTail, E.depsTail.nextDep = t, E.depsTail = t) : E.deps = E.depsTail = t, Me(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = E.depsTail, t.nextDep = void 0, E.depsTail.nextDep = t, E.depsTail = t, E.deps === t && (E.deps = e);
		}
		return process.env.NODE_ENV !== "production" && E.onTrack && E.onTrack(c({ effect: E }, e)), t;
	}
	trigger(e) {
		this.version++, ke++, this.notify(e);
	}
	notify(e) {
		_e();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(c({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			ve();
		}
	}
};
function Me(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) Me(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var Ne = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), Pe = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), Fe = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function j(e, t, n) {
	if (k && E) {
		let r = Ne.get(e);
		r || Ne.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new je()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function M(e, t, n, r, i, a) {
	let o = Ne.get(e);
	if (!o) {
		ke++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (_e(), t === "clear") o.forEach(s);
	else {
		let i = f(e), a = i && S(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === Fe || !_(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(Fe)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(A)), p(e) && s(o.get(Pe)));
				break;
			case "delete":
				i || (s(o.get(A)), p(e) && s(o.get(Pe)));
				break;
			case "set":
				p(e) && s(o.get(A));
				break;
		}
	}
	ve();
}
function N(e) {
	let t = /* @__PURE__ */ B(e);
	return t === e ? t : (j(t, "iterate", Fe), /* @__PURE__ */ z(e) ? t : t.map(V));
}
function Ie(e) {
	return j(e = /* @__PURE__ */ B(e), "iterate", Fe), e;
}
function P(e, t) {
	return /* @__PURE__ */ R(e) ? vt(/* @__PURE__ */ L(e) ? V(t) : t) : V(t);
}
var Le = {
	__proto__: null,
	[Symbol.iterator]() {
		return Re(this, Symbol.iterator, (e) => P(this, e));
	},
	concat(...e) {
		return N(this).concat(...e.map((e) => f(e) ? N(e) : e));
	},
	entries() {
		return Re(this, "entries", (e) => (e[1] = P(this, e[1]), e));
	},
	every(e, t) {
		return F(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return F(this, "filter", e, t, (e) => e.map((e) => P(this, e)), arguments);
	},
	find(e, t) {
		return F(this, "find", e, t, (e) => P(this, e), arguments);
	},
	findIndex(e, t) {
		return F(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return F(this, "findLast", e, t, (e) => P(this, e), arguments);
	},
	findLastIndex(e, t) {
		return F(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return F(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return Ve(this, "includes", e);
	},
	indexOf(...e) {
		return Ve(this, "indexOf", e);
	},
	join(e) {
		return N(this).join(e);
	},
	lastIndexOf(...e) {
		return Ve(this, "lastIndexOf", e);
	},
	map(e, t) {
		return F(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return I(this, "pop");
	},
	push(...e) {
		return I(this, "push", e);
	},
	reduce(e, ...t) {
		return Be(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return Be(this, "reduceRight", e, t);
	},
	shift() {
		return I(this, "shift");
	},
	some(e, t) {
		return F(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return I(this, "splice", e);
	},
	toReversed() {
		return N(this).toReversed();
	},
	toSorted(e) {
		return N(this).toSorted(e);
	},
	toSpliced(...e) {
		return N(this).toSpliced(...e);
	},
	unshift(...e) {
		return I(this, "unshift", e);
	},
	values() {
		return Re(this, "values", (e) => P(this, e));
	}
};
function Re(e, t, n) {
	let r = Ie(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ z(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var ze = Array.prototype;
function F(e, t, n, r, i, a) {
	let o = Ie(e), s = o !== e && !/* @__PURE__ */ z(e), c = o[t];
	if (c !== ze[t]) {
		let t = c.apply(e, a);
		return s ? V(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, P(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function Be(e, t, n, r) {
	let i = Ie(e), a = i !== e && !/* @__PURE__ */ z(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = P(e, t)), n.call(this, t, P(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? P(e, c) : c;
}
function Ve(e, t, n) {
	let r = /* @__PURE__ */ B(e);
	j(r, "iterate", Fe);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ gt(n[0]) ? (n[0] = /* @__PURE__ */ B(n[0]), r[t](...n)) : i;
}
function I(e, t, n = []) {
	Ee(), _e();
	let r = (/* @__PURE__ */ B(e))[t].apply(e, n);
	return ve(), De(), r;
}
var He = /* @__PURE__ */ r("__proto__,__v_isRef,__isVue"), Ue = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(_));
function We(e) {
	_(e) || (e = String(e));
	let t = /* @__PURE__ */ B(this);
	return j(t, "has", e), t.hasOwnProperty(e);
}
var Ge = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? ut : lt : i ? ct : st).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = f(e);
		if (!r) {
			let e;
			if (a && (e = Le[t])) return e;
			if (t === "hasOwnProperty") return We;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ H(e) ? e : n);
		if ((_(t) ? Ue.has(t) : He(t)) || (r || j(e, "get", t), i)) return o;
		if (/* @__PURE__ */ H(o)) {
			let e = a && S(t) ? o : o.value;
			return r && v(e) ? /* @__PURE__ */ pt(e) : e;
		}
		return v(o) ? r ? /* @__PURE__ */ pt(o) : /* @__PURE__ */ ft(o) : o;
	}
}, Ke = class extends Ge {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = f(e) && S(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ R(i);
			if (!/* @__PURE__ */ z(n) && !/* @__PURE__ */ R(n) && (i = /* @__PURE__ */ B(i), n = /* @__PURE__ */ B(n)), !a && /* @__PURE__ */ H(i) && !/* @__PURE__ */ H(n)) return r ? (process.env.NODE_ENV !== "production" && T(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : d(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ H(e) ? e : r);
		return e === /* @__PURE__ */ B(r) && s && (o ? w(n, i) && M(e, "set", t, n, i) : M(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = d(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && M(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!_(t) || !Ue.has(t)) && j(e, "has", t), n;
	}
	ownKeys(e) {
		return j(e, "iterate", f(e) ? "length" : A), Reflect.ownKeys(e);
	}
}, qe = class extends Ge {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && T(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && T(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, Je = /* @__PURE__ */ new Ke(), Ye = /* @__PURE__ */ new qe(), Xe = /* @__PURE__ */ new qe(!0), Ze = (e) => e, Qe = (e) => Reflect.getPrototypeOf(e);
function $e(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ B(i), o = p(a), s = e === "entries" || e === Symbol.iterator && o, l = e === "keys" && o, u = i[e](...r), d = n ? Ze : t ? vt : V;
		return !t && j(a, "iterate", l ? Pe : A), c(Object.create(u), { next() {
			let { value: e, done: t } = u.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [d(e[0]), d(e[1])] : d(e),
				done: t
			};
		} });
	};
}
function et(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			T(`${C(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ B(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function tt(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ B(r), a = /* @__PURE__ */ B(n);
			e || (w(n, a) && j(i, "get", n), j(i, "get", a));
			let { has: o } = Qe(i), s = t ? Ze : e ? vt : V;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && j(/* @__PURE__ */ B(t), "iterate", A), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ B(n), i = /* @__PURE__ */ B(t);
			return e || (w(t, i) && j(r, "has", t), j(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ B(a), s = t ? Ze : e ? vt : V;
			return !e && j(o, "iterate", A), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return c(n, e ? {
		add: et("add"),
		set: et("set"),
		delete: et("delete"),
		clear: et("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ B(this), r = Qe(n), i = /* @__PURE__ */ B(e), a = !t && !/* @__PURE__ */ z(e) && !/* @__PURE__ */ R(e) ? i : e;
			return r.has.call(n, a) || w(e, a) && r.has.call(n, e) || w(i, a) && r.has.call(n, i) || (n.add(a), M(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ z(n) && !/* @__PURE__ */ R(n) && (n = /* @__PURE__ */ B(n));
			let r = /* @__PURE__ */ B(this), { has: i, get: a } = Qe(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && ot(r, i, e) : (e = /* @__PURE__ */ B(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? w(n, s) && M(r, "set", e, n, s) : M(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ B(this), { has: n, get: r } = Qe(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && ot(t, n, e) : (e = /* @__PURE__ */ B(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && M(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ B(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : p(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && M(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = $e(r, e, t);
	}), n;
}
function nt(e, t) {
	let n = tt(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(d(n, r) && r in t ? n : t, r, i);
}
var rt = { get: /* @__PURE__ */ nt(!1, !1) }, it = { get: /* @__PURE__ */ nt(!0, !1) }, at = { get: /* @__PURE__ */ nt(!0, !0) };
function ot(e, t, n) {
	let r = /* @__PURE__ */ B(n);
	if (r !== n && t.call(e, r)) {
		let t = b(e);
		T(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var st = /* @__PURE__ */ new WeakMap(), ct = /* @__PURE__ */ new WeakMap(), lt = /* @__PURE__ */ new WeakMap(), ut = /* @__PURE__ */ new WeakMap();
function dt(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function ft(e) {
	return /* @__PURE__ */ R(e) ? e : ht(e, !1, Je, rt, st);
}
// @__NO_SIDE_EFFECTS__
function pt(e) {
	return ht(e, !0, Ye, it, lt);
}
// @__NO_SIDE_EFFECTS__
function mt(e) {
	return ht(e, !0, Xe, at, ut);
}
function ht(e, t, n, r, i) {
	if (!v(e)) return process.env.NODE_ENV !== "production" && T(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = dt(b(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function L(e) {
	return /* @__PURE__ */ R(e) ? /* @__PURE__ */ L(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function R(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function z(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function gt(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function B(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ B(t) : e;
}
function _t(e) {
	return !d(e, "__v_skip") && Object.isExtensible(e) && ne(e, "__v_skip", !0), e;
}
var V = (e) => v(e) ? /* @__PURE__ */ ft(e) : e, vt = (e) => v(e) ? /* @__PURE__ */ pt(e) : e;
// @__NO_SIDE_EFFECTS__
function H(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function yt(e) {
	return /* @__PURE__ */ H(e) ? e.value : e;
}
var bt = {
	get: (e, t, n) => t === "__v_raw" ? e : yt(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ H(i) && !/* @__PURE__ */ H(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function xt(e) {
	return /* @__PURE__ */ L(e) ? e : new Proxy(e, bt);
}
var St = {}, Ct = /* @__PURE__ */ new WeakMap(), U = void 0;
function wt(e, t = !1, n = U) {
	if (n) {
		let t = Ct.get(n);
		t || Ct.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && T("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function Tt(e, t, n = i) {
	let { immediate: r, deep: o, once: s, scheduler: c, augmentJob: u, call: d } = n, p = (e) => {
		(n.onWarn || T)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, m = (e) => o ? e : /* @__PURE__ */ z(e) || o === !1 || o === 0 ? W(e, 1) : W(e), g, _, v, ee, te = !1, y = !1;
	if (/* @__PURE__ */ H(e) ? (_ = () => e.value, te = /* @__PURE__ */ z(e)) : /* @__PURE__ */ L(e) ? (_ = () => m(e), te = !0) : f(e) ? (y = !0, te = e.some((e) => /* @__PURE__ */ L(e) || /* @__PURE__ */ z(e)), _ = () => e.map((e) => {
		if (/* @__PURE__ */ H(e)) return e.value;
		if (/* @__PURE__ */ L(e)) return m(e);
		if (h(e)) return d ? d(e, 2) : e();
		process.env.NODE_ENV !== "production" && p(e);
	})) : h(e) ? _ = t ? d ? () => d(e, 2) : e : () => {
		if (v) {
			Ee();
			try {
				v();
			} finally {
				De();
			}
		}
		let t = U;
		U = g;
		try {
			return d ? d(e, 3, [ee]) : e(ee);
		} finally {
			U = t;
		}
	} : (_ = a, process.env.NODE_ENV !== "production" && p(e)), t && o) {
		let e = _, t = o === !0 ? Infinity : o;
		_ = () => W(e(), t);
	}
	let b = fe(), x = () => {
		g.stop(), b && b.active && l(b.effects, g);
	};
	if (s && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return x(), n;
		};
	}
	let S = y ? Array(e.length).fill(St) : St, C = (e) => {
		if (!(!(g.flags & 1) || !g.dirty && !e)) if (t) {
			let n = g.run();
			if (e || o || te || (y ? n.some((e, t) => w(e, S[t])) : w(n, S))) {
				v && v();
				let e = U;
				U = g;
				try {
					let e = [
						n,
						S === St ? void 0 : y && S[0] === St ? [] : S,
						ee
					];
					S = n, d ? d(t, 3, e) : t(...e);
				} finally {
					U = e;
				}
			}
		} else g.run();
	};
	return u && u(C), g = new me(_), g.scheduler = c ? () => c(C, !1) : C, ee = (e) => wt(e, !1, g), v = g.onStop = () => {
		let e = Ct.get(g);
		if (e) {
			if (d) d(e, 4);
			else for (let t of e) t();
			Ct.delete(g);
		}
	}, process.env.NODE_ENV !== "production" && (g.onTrack = n.onTrack, g.onTrigger = n.onTrigger), t ? r ? C(!0) : S = g.run() : c ? c(C.bind(null, !0), !0) : g.run(), x.pause = g.pause.bind(g), x.resume = g.resume.bind(g), x.stop = x, x;
}
function W(e, t = Infinity, n) {
	if (t <= 0 || !v(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ H(e)) W(e.value, t, n);
	else if (f(e)) for (let r = 0; r < e.length; r++) W(e[r], t, n);
	else if (m(e) || p(e)) e.forEach((e) => {
		W(e, t, n);
	});
	else if (x(e)) {
		for (let r in e) W(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && W(e[r], t, n);
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/@vue+runtime-core@3.5.40/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var G = [];
function Et(e) {
	G.push(e);
}
function Dt() {
	G.pop();
}
var Ot = !1;
function K(e, ...t) {
	if (Ot) return;
	Ot = !0, Ee();
	let n = G.length ? G[G.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = kt();
	if (r) Ft(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${pr(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...At(i)), console.warn(...n);
	}
	De(), Ot = !1;
}
function kt() {
	let e = G[G.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function At(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...jt(e));
	}), t;
}
function jt({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${pr(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Mt(e.props),
		a
	] : [i + a];
}
function Mt(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Nt(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Nt(e, t, n) {
	return g(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ H(t) ? (t = Nt(e, /* @__PURE__ */ B(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : h(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ B(t), n ? t : [`${e}=`, t]);
}
var Pt = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function Ft(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Lt(e, t, n);
	}
}
function It(e, t, n, r) {
	if (h(e)) {
		let i = Ft(e, t, n, r);
		return i && ee(i) && i.catch((e) => {
			Lt(e, t, n);
		}), i;
	}
	if (f(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(It(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && K(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function Lt(e, t, n, r = !0) {
	let a = t ? t.vnode : null, { errorHandler: o, throwUnhandledErrorInProduction: s } = t && t.appContext.config || i;
	if (t) {
		let r = t.parent, i = t.proxy, a = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : Pt[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, a) === !1) return;
			}
			r = r.parent;
		}
		if (o) {
			Ee(), Ft(o, null, 10, [
				e,
				i,
				a
			]), De();
			return;
		}
	}
	Rt(e, n, a, r, s);
}
function Rt(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = Pt[t];
		if (n && Et(n), K(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Dt(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var q = [], J = -1, Y = [], X = null, Z = 0, zt = /* @__PURE__ */ Promise.resolve(), Bt = null, Vt = 100;
function Ht(e) {
	let t = Bt || zt;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function Ut(e) {
	let t = J + 1, n = q.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = q[r], a = Jt(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function Wt(e) {
	if (!(e.flags & 1)) {
		let t = Jt(e), n = q[q.length - 1];
		!n || !(e.flags & 2) && t >= Jt(n) ? q.push(e) : q.splice(Ut(t), 0, e), e.flags |= 1, Gt();
	}
}
function Gt() {
	Bt ||= zt.then(Yt);
}
function Kt(e) {
	f(e) ? Y.push(...e) : X && e.id === -1 ? X.splice(Z + 1, 0, e) : e.flags & 1 || (Y.push(e), e.flags |= 1), Gt();
}
function qt(e) {
	if (Y.length) {
		let t = [...new Set(Y)].sort((e, t) => Jt(e) - Jt(t));
		if (Y.length = 0, X) {
			X.push(...t);
			return;
		}
		for (X = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Z = 0; Z < X.length; Z++) {
			let t = X[Z];
			process.env.NODE_ENV !== "production" && Xt(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		X = null, Z = 0;
	}
}
var Jt = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function Yt(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? a : (t) => Xt(e, t);
	try {
		for (J = 0; J < q.length; J++) {
			let e = q[J];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), Ft(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; J < q.length; J++) {
			let e = q[J];
			e && (e.flags &= -2);
		}
		J = -1, q.length = 0, qt(e), Bt = null, (q.length || Y.length) && Yt(e);
	}
}
function Xt(e, t) {
	let n = e.get(t) || 0;
	if (n > Vt) {
		let e = t.i, n = e && fr(e.type);
		return Lt(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Zt = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ie().__VUE_HMR_RUNTIME__ = {
	createRecord: an($t),
	rerender: an(tn),
	reload: an(nn)
});
var Qt = /* @__PURE__ */ new Map();
function $t(e, t) {
	return Qt.has(e) ? !1 : (Qt.set(e, {
		initialDef: en(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function en(e) {
	return mr(e) ? e.__vccOpts : e;
}
function tn(e, t) {
	let n = Qt.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, en(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function nn(e, t) {
	let n = Qt.get(e);
	if (!n) return;
	t = en(t), rn(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = en(i.type), o = Zt.get(a);
		o || (a !== n.initialDef && rn(a, t), Zt.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? Wt(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Kt(() => {
		Zt.clear();
	});
}
function rn(e, t) {
	c(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function an(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var on, sn = [];
function cn(e, t) {
	on = e, on ? (on.enabled = !0, sn.forEach(({ event: e, args: t }) => on.emit(e, ...t)), sn = []) : typeof window < "u" && window.HTMLElement && !(window.navigator?.userAgent)?.includes("jsdom") ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((e) => {
		cn(e, t);
	}), setTimeout(() => {
		on || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, sn = []);
	}, 3e3)) : sn = [];
}
var Q = null, ln = null;
function un(e, t, n = !1) {
	let r = ir();
	if (r || Pn) {
		let i = Pn ? Pn._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && h(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && K(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && K("inject() can only be used inside setup() or functional components.");
}
var dn = /* @__PURE__ */ Symbol.for("v-scx"), fn = () => {
	{
		let e = un(dn);
		return e || process.env.NODE_ENV !== "production" && K("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function pn(e, t, n = i) {
	let { immediate: r, deep: o, flush: s, once: l } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && K("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && K("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), l !== void 0 && K("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let u = c({}, n);
	process.env.NODE_ENV !== "production" && (u.onWarn = K);
	let d = t && r || !t && s !== "post", f;
	if (cr) {
		if (s === "sync") {
			let e = fn();
			f = e.__watcherHandles ||= [];
		} else if (!d) {
			let e = () => {};
			return e.stop = a, e.resume = a, e.pause = a, e;
		}
	}
	let p = rr;
	u.call = (e, t, n) => It(e, p, t, n);
	let m = !1;
	s === "post" ? u.scheduler = (e) => {
		Ln(e, p && p.suspense);
	} : s !== "sync" && (m = !0, u.scheduler = (e, t) => {
		t ? e() : Wt(e);
	}), u.augmentJob = (e) => {
		t && (e.flags |= 4), m && (e.flags |= 2, p && (e.id = p.uid, e.i = p));
	};
	let h = Tt(e, t, u);
	return cr && (f ? f.push(h) : d && h()), h;
}
function mn(e, t, n) {
	let r = this.proxy, i = g(e) ? e.includes(".") ? hn(r, e) : () => r[e] : e.bind(r, r), a;
	h(t) ? a = t : (a = t.handler, n = t);
	let o = or(this), s = pn(i, a.bind(r), n);
	return o(), s;
}
function hn(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var gn = (e) => e.__isTeleport;
function _n(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, _n(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
ie().requestIdleCallback, ie().cancelIdleCallback;
var vn = /* @__PURE__ */ Symbol.for("v-ndc"), yn = (e) => e ? sr(e) ? lr(e) : yn(e.parent) : null, bn = /* @__PURE__ */ c(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ mt(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ mt(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ mt(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ mt(e.refs),
	$parent: (e) => yn(e.parent),
	$root: (e) => yn(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => __VUE_OPTIONS_API__ ? Tn(e) : e.type,
	$forceUpdate: (e) => e.f ||= () => {
		Wt(e.update);
	},
	$nextTick: (e) => e.n ||= Ht.bind(e.proxy),
	$watch: (e) => __VUE_OPTIONS_API__ ? mn.bind(e) : a
}), xn = (e, t) => e !== i && !e.__isScriptSetup && d(e, t), Sn = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: a, props: o, accessCache: s, type: c, appContext: l } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = s[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return a[t];
				case 4: return n[t];
				case 3: return o[t];
			}
			else if (xn(r, t)) return s[t] = 1, r[t];
			else if (__VUE_OPTIONS_API__ && a !== i && d(a, t)) return s[t] = 2, a[t];
			else if (d(o, t)) return s[t] = 3, o[t];
			else if (n !== i && d(n, t)) return s[t] = 4, n[t];
			else (!__VUE_OPTIONS_API__ || wn) && (s[t] = 0);
		}
		let u = bn[t], f, p;
		if (u) return t === "$attrs" ? (j(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && j(e, "get", t), u(e);
		if ((f = c.__cssModules) && (f = f[t])) return f;
		if (n !== i && d(n, t)) return s[t] = 4, n[t];
		if (p = l.config.globalProperties, d(p, t)) return p[t];
		process.env.NODE_ENV;
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: a, ctx: o } = e;
		return xn(a, t) ? (a[t] = n, !0) : process.env.NODE_ENV !== "production" && a.__isScriptSetup && d(a, t) ? (K(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : __VUE_OPTIONS_API__ && r !== i && d(r, t) ? (r[t] = n, !0) : d(e.props, t) ? (process.env.NODE_ENV !== "production" && K(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && K(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(o, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : o[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: a, props: o, type: s } }, c) {
		let l;
		return !!(n[c] || __VUE_OPTIONS_API__ && e !== i && c[0] !== "$" && d(e, c) || xn(t, c) || d(o, c) || d(r, c) || d(bn, c) || d(a.config.globalProperties, c) || (l = s.__cssModules) && l[c]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? d(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (Sn.ownKeys = (e) => (K("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function Cn(e) {
	return f(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var wn = !0;
function Tn(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => En(c, e, o, !0)), En(c, t, o)), v(t) && a.set(t, c), c;
}
function En(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && En(e, a, n, !0), i && i.forEach((t) => En(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && K("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = Dn[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var Dn = {
	data: On,
	props: Mn,
	emits: Mn,
	methods: jn,
	computed: jn,
	beforeCreate: $,
	created: $,
	beforeMount: $,
	mounted: $,
	beforeUpdate: $,
	updated: $,
	beforeDestroy: $,
	beforeUnmount: $,
	destroyed: $,
	unmounted: $,
	activated: $,
	deactivated: $,
	errorCaptured: $,
	serverPrefetch: $,
	components: jn,
	directives: jn,
	watch: Nn,
	provide: On,
	inject: kn
};
function On(e, t) {
	return t ? e ? function() {
		return c(h(e) ? e.call(this, this) : e, h(t) ? t.call(this, this) : t);
	} : t : e;
}
function kn(e, t) {
	return jn(An(e), An(t));
}
function An(e) {
	if (f(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function $(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function jn(e, t) {
	return e ? c(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Mn(e, t) {
	return e ? f(e) && f(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : c(/* @__PURE__ */ Object.create(null), Cn(e), Cn(t ?? {})) : t;
}
function Nn(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = c(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = $(e[r], t[r]);
	return n;
}
var Pn = null, Fn = {}, In = (e) => Object.getPrototypeOf(e) === Fn, Ln = zn, Rn = (e) => e.__isSuspense;
function zn(e, t) {
	t && t.pendingBranch ? f(e) ? t.effects.push(...e) : t.effects.push(e) : Kt(e);
}
var Bn = /* @__PURE__ */ Symbol.for("v-fgt"), Vn = /* @__PURE__ */ Symbol.for("v-txt"), Hn = /* @__PURE__ */ Symbol.for("v-cmt");
function Un(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var Wn, Gn = (...e) => Xn(...Wn ? Wn(e, Q) : e), Kn = ({ key: e }) => e ?? null, qn = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : g(e) || /* @__PURE__ */ H(e) || h(e) ? {
	i: Q,
	r: e,
	k: t,
	f: !!n
} : e);
function Jn(e, t = null, n = null, r = 0, i = null, a = e === Bn ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && Kn(t),
		ref: t && qn(t),
		scopeId: ln,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: Q
	};
	return s ? (tr(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= g(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && K("VNode created with invalid key (NaN). VNode type:", c.type), c;
}
var Yn = process.env.NODE_ENV === "production" ? Xn : Gn;
function Xn(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === vn) && (process.env.NODE_ENV !== "production" && !e && K(`Invalid vnode type when creating vnode: ${e}.`), e = Hn), Un(e)) {
		let r = Qn(e, t, !0);
		return n && tr(r, n), r.patchFlag = -2, r;
	}
	if (mr(e) && (e = e.__vccOpts), t) {
		t = Zn(t);
		let { class: e, style: n } = t;
		e && !g(e) && (t.class = ue(e)), v(n) && (/* @__PURE__ */ gt(n) && !f(n) && (n = c({}, n)), t.style = ae(n));
	}
	let o = g(e) ? 1 : Rn(e) ? 128 : gn(e) ? 64 : v(e) ? 4 : h(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ gt(e) && (e = /* @__PURE__ */ B(e), K("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Jn(e, t, n, r, i, o, a, !0);
}
function Zn(e) {
	return e ? /* @__PURE__ */ gt(e) || In(e) ? c({}, e) : e : null;
}
function Qn(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? nr(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && Kn(l),
		ref: t && t.ref ? n && a ? f(a) ? a.concat(qn(t)) : [a, qn(t)] : qn(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && f(s) ? s.map($n) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== Bn ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Qn(e.ssContent),
		ssFallback: e.ssFallback && Qn(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && _n(u, c.clone(u)), u;
}
function $n(e) {
	let t = Qn(e);
	return f(e.children) && (t.children = e.children.map($n)), t;
}
function er(e = " ", t = 0) {
	return Yn(Vn, null, e, t);
}
function tr(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (f(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), tr(e, n()), n._c && (n._d = !0));
		return;
	} else n = 32, !t._ && !In(t) && (t._ctx = Q);
	else if (h(t)) {
		if (r & 65) {
			tr(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: Q
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [er(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function nr(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = ue([t.class, r.class]));
		else if (e === "style") t.style = ae([t.style, r.style]);
		else if (o(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(f(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !s(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var rr = null, ir = () => rr || Q, ar;
{
	let e = ie(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	ar = t("__VUE_INSTANCE_SETTERS__", (e) => rr = e), t("__VUE_SSR_SETTERS__", (e) => cr = e);
}
var or = (e) => {
	let t = rr;
	return ar(e), e.scope.on(), () => {
		e.scope.off(), ar(t);
	};
};
function sr(e) {
	return e.vnode.shapeFlag & 4;
}
var cr = !1;
process.env.NODE_ENV;
function lr(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(xt(_t(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in bn) return bn[n](e);
		},
		has(e, t) {
			return t in e || t in bn;
		}
	}) : e.proxy;
}
var ur = /(?:^|[-_])\w/g, dr = (e) => e.replace(ur, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function fr(e, t = !0) {
	return h(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function pr(e, t, n = !1) {
	let r = fr(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? dr(r) : n ? "App" : "Anonymous";
}
function mr(e) {
	return h(e) && "__vccOpts" in e;
}
function hr() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, a = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!v(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ H(t)) {
				Ee();
				let n = t.value;
				return De(), [
					"div",
					{},
					[
						"span",
						e,
						p(t)
					],
					"<",
					l(n),
					">"
				];
			} else if (/* @__PURE__ */ L(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ z(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				l(t),
				`>${/* @__PURE__ */ R(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ R(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ z(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				l(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...o(e.$)
			];
		}
	};
	function o(e) {
		let t = [];
		e.type.props && e.props && t.push(s("props", /* @__PURE__ */ B(e.props))), e.setupState !== i && t.push(s("setup", e.setupState)), e.data !== i && t.push(s("data", /* @__PURE__ */ B(e.data)));
		let n = u(e, "computed");
		n && t.push(s("computed", n));
		let a = u(e, "inject");
		return a && t.push(s("injected", a)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function s(e, t) {
		return t = c({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					l(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function l(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : v(e) ? ["object", { object: i ? /* @__PURE__ */ B(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function u(e, t) {
		let n = e.type;
		if (h(n)) return;
		let r = {};
		for (let i in e.ctx) d(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function d(e, t, n) {
		let r = e[n];
		if (f(r) && r.includes(t) || v(r) && t in r || e.extends && d(e.extends, t, n) || e.mixins && e.mixins.some((e) => d(e, t, n))) return !0;
	}
	function p(e) {
		return /* @__PURE__ */ z(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(a) : window.devtoolsFormatters = [a];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
//#endregion
//#region ../../node_modules/.pnpm/vue@3.5.40_typescript@6.0.3/node_modules/vue/dist/vue.runtime.esm-bundler.js
function gr() {
	hr();
}
process.env.NODE_ENV !== "production" && gr();
//#endregion
export { n, t as r, e as t };
